import React, { createContext, useState, useContext, useEffect } from 'react';

// Crear un contexto
const AuthContext = createContext();

// Proveedor del contexto
export function AuthProvider({ children }) {
  const [accessToken, setAccessToken] = useState(null);
  const [user, setUser] = useState(null);
  const [idColaborador, setIdColaborador] = useState(null);
  const [perfil, setPerfil] = useState('Colaborador');
  const [authReady, setAuthReady] = useState(false); // 👈 NUEVO

  const [formDataIncoop, setFormDataIncoop] = useState({
    numero_identificacion: '',
    apellidos: '',
    nombres: '',
    tipo_identificacion: '',
    pais_nacimiento: '',
    provincia_nacimiento: '',
    fecha_nacimiento: '',
    sexo: '',
    nivel_instruccion: '',
    nacionalidad: '',
    estado_civil: '',
    etnia: '',
    apellidosConyugue: '',
    nombresConyugue: '',
    tipo_identificacionConyugue: '',
    numero_identificacionConyugue: '',
    fecha_nacimientoConyugue: '',
    pais_nacimientoConyugue: '',
    profesionConyugue: '',
    actividad_economicaConyugue: '',
    nacionalidadConyugue: '',
    nivel_instruccionConyugue: '',
    ingresos_mensualesConyugue: '',
    correo_electronicoConyugue: '',
    numerocargas: '',
    pais_trabajo: '',
    provincia_trabajo: '',
    canton_trabajo: '',
    ciudad_trabajo: '',
    parroquia_trabajo: '',
    tipovivienda: '',
    sueldoempresa: '',
    total_activos: '',
    total_pasivos: '',
    total_egresos: '',
    total_ingresos: '',
    fecha_ingreso_empresa: '',
    pais_domicilio: '',
    provincia_domicilio: '',
    canton_domicilio: '',
    ciudad_domicilio: '',
    parroquia_domicilio: '',
    sector_barrio_domicilio: '',
    calle_principal_domicilio: '',
    numero_domicilio: '',
    calle_secundaria_domicilio: '',
    tiempo_residencia: '',
    telefono_domicilio: '',
    celular: '',
    correo_electronico: '',
    punto_referencia: '',
    codigo_postal: '',
    condicion_laboral: '',
    condicion_laboral_educacional: '',
    nombre_empresa: '',
    actividad_economica: '',
    cargo: '',
    profesion: '',
    tiempo_antiguedad: '',
    direccion_empresa: '',
    telefono_trabajo: '',
    otra_actividad_economica: '',
    pep: '',
    ingresos_fijos: '',
    ingresos_conyuge: '',
    otros_ingresos: '',
    origen_otros_ingresos: '',
    egresos_servicios: '',
    egresos_arriendo: '',
    egresos_educacion: '',
    egresos_vestimenta: '',
    egresos_prestamos: '',
    egresos_tarjetas: '',
    egresos_transporte: '',
    egresos_salud: '',
    egresos_alimentacion: '',
    otros_egresos: '',
    bienes_muebles: '',
    bienes_inmuebles: '',
    vehiculos: '',
    inversiones: '',
    caja_bancos: '',
    otros_activos: '',
    deudas_ifis: '',
    deudas_tarjetas: '',
    otros_pasivos: '',
    nombres_apellidos: '',
    parentesco: '',
    direccion_domiciliaria: '',
    telefono_convencional: '',
    telefono_celular: '',
  });

  useEffect(() => {
    // Hidratar desde sessionStorage al cargar
    const storedToken = sessionStorage.getItem('accessToken');
    const storedUser = sessionStorage.getItem('user');
    const storedIdColaborador = sessionStorage.getItem('idColaborador'); // 👈 NUEVO

    if (storedToken) setAccessToken(storedToken);
    if (storedUser) setUser(JSON.parse(storedUser));
    if (storedIdColaborador) setIdColaborador(storedIdColaborador); // 👈 NUEVO

    setAuthReady(true); // 👈 Listo para redireccionar
  }, []);

  // Persistir idColaborador cuando cambie
  useEffect(() => {
    if (idColaborador) {
      sessionStorage.setItem('idColaborador', idColaborador);
    } else {
      sessionStorage.removeItem('idColaborador');
    }
  }, [idColaborador]);

  const login = (newAccessToken, newUser) => {
    setAccessToken(newAccessToken);
    setUser(newUser);
    sessionStorage.setItem('accessToken', newAccessToken);
    sessionStorage.setItem('user', JSON.stringify(newUser));
  };

  const logout = () => {
    setAccessToken(null);
    setUser(null);
    setIdColaborador(null); // 👈 limpiar en memoria
    sessionStorage.removeItem('accessToken');
    sessionStorage.removeItem('user');
    sessionStorage.removeItem('idColaborador'); // 👈 limpiar en storage
  };

  return (
    <AuthContext.Provider
      value={{
        formDataIncoop,
        accessToken,
        user,
        login,
        logout,
        perfil,
        setPerfil,
        idColaborador,
        setIdColaborador,
        authReady, // 👈 expuesto
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

// Hook para consumir el contexto
export function useAuth() {
  return useContext(AuthContext);
}
